/**
 * Sharetribe custom-media widths NOT covered by theme.breakpoints (sm/md/lg already match
 * 600/900/1200). theme.breakpoints.xl is 1440 and is NOT the Sharetribe XLarge (1921).
 * Values mirror src/styles/customMediaQueries.css.
 * @returns {{ viewportLargeWithPaddings: string, viewportXLarge: string }}
 */
export const createCustomMedia = () => ({
  viewportLargeWithPaddings: '@media (min-width:1304px)',
  viewportXLarge: '@media (min-width:1921px)',
});
